export default __webpack_public_path__ + "img/fLHlmMAz.63fc1ef5.svg";